/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Chat_Ask_User_Answers_SentInputs */



/**
* | output |
* | --- |
* | "Answered {count} questions" |
*
* @param {Chat_Ask_User_Answers_SentInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_ask_user_answers_sent = /** @type {((inputs: Chat_Ask_User_Answers_SentInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Ask_User_Answers_SentInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Fragen beantwortet`)
	return /** @type {LocalizedString} */ (`Answered ${i?.count} questions`)
});